import React, { useState } from 'react';
import { formatDateTime } from '../../../redux/services/utility';
import Iconify from '../../../components/Iconify';
import { useNavigate } from 'react-router-dom';
import PickupLocationIcon from "../../../assets/Pickup@4x.png";
import LocationIcon from "../../../assets/location.png";
import DateIcon from "../../../assets/calender.png";
import TimeIcon from "../../../assets/Time@4x.png";
import clearIcon from "../../../assets/Cancel.png";
import Download from "../../../assets/invoice Download@4x.png";
import LoaderIcon from "../../../assets/animated-loader.gif"; 


interface Booking {
    id: string;
    bookingCode: string;
    bookingStatus: string;
    parkingSpaceLocationRespDTO: {
        imageList: { filePreSignedUrl: string }[];
    };
    fromLocation: string;
    toLocation: string;
    checkinTime: string;
    checkoutTime: string;
    isDownloadInvoiceLoading: boolean;
    isCancelBookingLoading: boolean;
}

interface Props {
    booking: Booking;
    filter: string;
    handleOpenModal: (value: any) => void;
    handleDownloadInvoice: (value: any) => void;
    isDownloadInvoiceLoading: boolean;
    isCancelBookingLoading: boolean;
}

const BookingCard: React.FC<Props> = ({ booking, filter, handleOpenModal, handleDownloadInvoice, isDownloadInvoiceLoading, isCancelBookingLoading }) => {
    const navigate = useNavigate();
    
    return (
        <div className="bg-[#F9F4EF] cursor-pointer rounded-2xl p-4 flex md:flex-row flex-col items-center gap-4 shadow-lg">
            <div className="md:w-[40%] lg:w-[20%] w-full h-34 "
                onClick={() => {
                    navigate("/profile/my-booking-detail", {
                        state: { bookingDetails: booking },
                    });
                }}
            >
                <img
                    src={booking.parkingSpaceLocationRespDTO?.imageList[0]?.filePreSignedUrl}
                    alt="Car"
                    className="w-full  md:h-full h-[70%] object-cover rounded-lg"
                />
                <div className="bg-[#ED1C24] m-2 justify-between gap-2 p-1 flex text-white font-bold  rounded-full p-2">
                    <p className="text-[10px] ml-8 md:ml-0 uppercase">{booking.bookingStatus}</p>
                    <div className='border-l-2 border-white h-4'></div>
                    <p className="text-[10px] mr-8 md:mr-0">{booking.bookingCode}</p>
                </div>
            </div>
            <div className='md:w-[60%] lg:w-[80%] w-full'>
                <div
                    onClick={() => {
                        navigate("/profile/my-booking-detail", {
                            state: { bookingDetails: booking },
                        });
                    }}
                    className="flex md:flex-row flex-col md:gap-0 gap-2 justify-between md:items-center items-start">
                    <div className="flex md:w-[40%] lg:w-[50%] w-full items-center gap-2 ">
                        <img src={PickupLocationIcon} alt="From" className="w-4 h-4" />
                        <p className="text-sm font-semibold truncate overflow-hidden text-ellipsis whitespace-nowrap">
                            {booking.fromLocation.split(' ').slice(0, 10).join(' ')}{booking.fromLocation.split(' ').length > 10 ? '...' : ''}
                        </p>
                    </div>
                    {booking.toLocation && <span className="text-lg font-bold md:flex hidden text-gray-600">→</span>}
                    {booking.toLocation &&
                        <div className="flex md:w-[40%] lg:w-[50%] w-full items-center gap-2 ">
                            <img src={LocationIcon} alt="To" className="w-4 h-4" />
                            <p className="text-sm font-semibold truncate overflow-hidden text-ellipsis whitespace-nowrap">
                                {booking.toLocation.split(' ').slice(0, 8).join(' ')}{booking.toLocation.split(' ').length > 8 ? '...' : ''}
                            </p>
                        </div>
                    }

                </div>
                <div
                    onClick={() => {
                        navigate("/profile/my-booking-detail", {
                            state: { bookingDetails: booking },
                        });
                    }}
                    className="flex flex-row  md:gap-8 gap-4 text-xs text-gray-600 mt-2">
                    <div >
                        <div className="flex items-center gap-2">
                            <img src={TimeIcon} alt="Check-in time" className="w-4 h-4" />
                            <p>{formatDateTime(booking.checkinTime, "hh:mm A")}</p>
                        </div>
                        <div className="flex items-center mt-1 gap-2">
                            <img src={DateIcon} alt="Check-in date" className="w-4 h-4" />
                            <p>{formatDateTime(booking.checkinTime, "MM/DD/YYYY")}</p>
                        </div>

                    </div>
                    {booking.checkoutTime &&
                        <div>
                            <div className="flex items-center gap-1">
                                <img src={TimeIcon} alt="Checkout time" className="w-4 h-4" />
                                <p>{formatDateTime(booking.checkoutTime, "hh:mm A")}</p>
                            </div>
                            <div className="flex items-center mt-1 gap-1">
                                <img src={DateIcon} alt="Checkout date" className="w-4 h-4" />
                                <p>{formatDateTime(booking.checkoutTime, "MM/DD/YYYY")}</p>
                            </div>
                        </div>
                    }
                </div>
                {/* Booking Status */}
                <div className="">
                    {/* Action Buttons */}
                    <div className="flex justify-center gap-2 mt-2">
                        {filter === "CUSTOMER_UPCOMING_BOOKING" && (
                            <button
                                onClick={() => handleDownloadInvoice(booking)}
                                disabled={isDownloadInvoiceLoading} // Disable button while loading
                            >
                                {isDownloadInvoiceLoading ? (
                                    <img src={LoaderIcon} className="cursor-pointer w-5 h-5" />
                                ) : (
                                    <img src={Download} className="cursor-pointer w-5 h-5" />
                                )}
                            </button>
                        )}
                        {filter === "CUSTOMER_UPCOMING_BOOKING" && (
                            <button
                                onClick={() => handleOpenModal(booking)}
                                disabled={isCancelBookingLoading} // Disable button while loading
                            >
                                {isCancelBookingLoading ? (
                                    <img src={LoaderIcon} className="cursor-pointer w-5 h-5" />
                                ) : (
                                    <img src={clearIcon} className="cursor-pointer w-5 h-5" />
                                )}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingCard;
